<template>

    <div class="container-center">
        <el-tabs v-model="tagNo" @tab-click="handleTabClick">
            <el-tab-pane name="eva-list">
                <span slot="label"><i class="el-icon-news"></i> 综合得分</span>
                <peeva-list ref="evalist"></peeva-list>
            </el-tab-pane>
            <el-tab-pane name="detail-list">
                <span slot="label"><i class="el-icon-news"></i> 得分明细</span>
                <detail-list ref="detailList"></detail-list>
            </el-tab-pane>
            <!-- <el-tab-pane name="recover-list">
                <span slot="label"><i class="el-icon-news"></i> 投标资格回复请求函</span>
                <letter-list ref="letterList"> </letter-list>
            </el-tab-pane> -->
        </el-tabs>
    </div>

</template>

<script>
    import banner from '@/assets/imgs/banner_invite.png'
    import util from '@/util'
    import PerformanceEvaList from '@/pages/dsp/pfeva/PerformanceEvaList'
    import PerformDetailList from '@/pages/dsp/pfeva/PerformDetailList'
    import PerformRequestLetter from '@/pages/dsp/pfeva/PerformRequestLetter'
    export default {
        name: 'peeva-main',
        data () {
            return {
                tagNo: 'eva-list',
                from: ''
            }
        },
        components: {
            'peeva-list': PerformanceEvaList,
            'detail-list': PerformDetailList,
            'letter-list': PerformRequestLetter
        },
        methods: {
            tagJump (productsId) {
                if (productsId != null) {
                    this.$refs.detailList.form.serviceArray = [productsId]
                }
                this.tagNo = 'detail-list'
                this.from = 'jump';
                this.$refs.detailList.getPerevaList(this.from)
            },
            getProducts () {
                this.$http.get('/rest/api/ContractPerformance/getAllProducts?stockId=' + encodeURIComponent(this.$root.stockId)).then((res) => {
                    if (res.data.result) {
                        this.$refs.evalist.productList = res.data.value || []
                        this.$refs.detailList.productList = res.data.value || []
                    } else {
                        this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                    }
                })
            },
            handleTabClick(val){
                this.from = '';
                if(val.index=='0'){
                    this.$refs.evalist.form = {
                        stockId: this.$root.stockId || '',
                        serviceArray: [],
                        pageNum: 1,
                        pageSize: 10
                    };
                    this.$refs.evalist.getPerevaList()
                }
                if(val.index=='1'){
                    this.$refs.detailList.form = {
                        stockId: this.$root.stockId || '',
                        serviceArray: [],
                        projName: '',
                        conName: ''
                    };
                    this.$refs.detailList.getPerevaList(this.from)

                }
            }
        },
        created () {
            this.$root.navs = [{name: '履约评估', path: '/performanceEvaMain'}]
            this.$root.headImage.src = banner

            if (window.localStorage.getItem('isInMng')) {
                this.$root.isPublic = false
            }

            this.getProducts()

        },
        mounted () {
            if (this.$root.stockId) {
                util.hasIdCardNullFlag(this)
            }
        },

    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';


</style>



// WEBPACK FOOTER //
// src/pages/dsp/pfeva/PerformanceEvaMain.vue